import { render, staticRenderFns } from "./TipologiaCommissioneFondi.vue?vue&type=template&id=5530919c&"
import script from "./TipologiaCommissioneFondi.vue?vue&type=script&lang=js&"
export * from "./TipologiaCommissioneFondi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports